import { OVERNIGHT_BOARDING } from '@rover/constants/src/translations/services.constants';
import type { SearchFilters } from '@rover/types';
import { PetType } from '@rover/types/src/Pet';
import { ServiceFrequencyEnum } from '@rover/types/src/ServiceFrequency';

export function searchFiltersFactory(opts?: Partial<SearchFilters>): SearchFilters {
  return {
    acceptsOnlyOneClient: false,
    atDaycareFacility: true,
    adwordslocation: '',
    agency: [],
    apse: false,
    bathingGrooming: false,
    breeds: [],
    catCare: false,
    centerlat: undefined,
    centerlng: undefined,
    dogsAllowedOnBed: false,
    dogsAllowedOnFurniture: false,
    endDate: undefined,
    frequency: ServiceFrequencyEnum.ONE_TIME,
    morningAvailability: false,
    middayAvailability: false,
    eveningAvailability: false,
    fulltimeAvailability: true,
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false,
    giantDogs: false,
    hasFencedYard: false,
    hasHouse: false,
    hasNoChildren: false,
    inSittersHome: true,
    isInitialSearch: false,
    isPremier: false,
    knowsFirstAid: false,
    largeDogs: false,
    location: '',
    locationAccuracy: '5161',
    maxlat: undefined,
    maxlng: undefined,
    maxprice: undefined,
    mediumDogs: false,
    minlat: undefined,
    minlng: undefined,
    minprice: 1,
    noCagedPets: false,
    noCats: false,
    noChildren05: false,
    noChildren612: false,
    nonSmoking: false,
    page: 1,
    personDoesNotHaveDogs: false,
    pet: [],
    petsitusa: false,
    petType: [PetType.DOG],
    puppy: false,
    providerGroup: [],
    rawLocationTypes: [],
    selectedDays: [],
    serviceType: OVERNIGHT_BOARDING().type,
    smallDogs: false,
    spacesRequired: undefined,
    starSitter: false,
    startDate: undefined,
    searchScoreDebug: false,
    injectedMedication: false,
    searchCurrentProvider: false,
    inUnlaunchedCountry: false,
    specialNeeds: false,
    oralMedication: false,
    moreThanOneClient: false,
    uncratedDogs: false,
    unspayedFemales: false,
    nonNeuteredMales: false,
    femalesInHeat: false,
    premierMatching: false,
    premierOrRoverMatch: false,
    isMemberOfSitterToSitter: false,
    isMemberOfSitterToSitterPlus: false,
    isAcceptingNewRecurringClients: false,
    hasLowBookingRate: false,
    ...opts,
  };
}

export const petCountersFilters: Pick<SearchFilters, 'dogCount' | 'catCount' | 'puppyCount'> = {
  dogCount: 0,
  catCount: 0,
  puppyCount: 0,
};
